import { Discount } from '@aglenergy/shared-library';
import { NbnProductsResponse } from 'app/nbn/models/nbn-products-response.model';
import { ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';
import { EnergyProductsResponse, ProductsResponse } from 'app/shared/models/product-response.model';
import { RatesPeriod, SearchRequestType } from 'app/shared/models/energy/energy.enums';
import { AddressDetailModel } from 'app/shared/models/address/address.model';

export class BundleSearchStore {
  public request: CurrentSearchRequestModel;
  public energyResponse: EnergyProductsResponse;
  public nbnResponse: NbnProductsResponse;
  public mobileResponse: ProductsResponse;
  public discounts?: Array<Discount> | null;
  public requestDateTime: Date;
  public address?: AddressDetailModel;
}

export class EnergySearchStore {
  public request: CurrentSearchRequestModel;
  public response: EnergyProductsResponse;
  public requestDateTime: Date;
}

export class CurrentSearchRequestModel {
  public productSearchRequestModel: ProductSearchRequestModel;
  public selectedTariff = '';
  public selectedRatesPeriod: RatesPeriod = RatesPeriod.Current;

  constructor(
    public searchRequestType: SearchRequestType,
    requestModel: ProductSearchRequestModel,
    public addressString: string = null,
    public addressId: string,
    public hasError: boolean = false
  ) {
    // try to create the search request model
    this.productSearchRequestModel = new ProductSearchRequestModel();
    this.productSearchRequestModel = { ...requestModel };
  }
}
